import React from "react";
import {
  Box,
  Container,
  Typography,
  Paper,
  Grid,
  Divider
} from "@mui/material";
import ComboBoxWithSearch from "../componentes/ComboBoxWithSearch";
import ComboBoxActivo from "../componentes/ComboBoxActivo";
import ComboBoxTipoActivo from "../componentes/ComboBoxTipoActivo";
import Tabla from "../componentes/TablaActivo";
import Tabla1 from "../componentes/TablaValorImpacto";

export const Activos = () => {
  const [unidadSeleccionada, setUnidadSeleccionada] = React.useState(null);
  const [tipoActivoSeleccionado, setTipoActivoSeleccionado] =
    React.useState(null);
  const [activoSeleccionado, setActivoSeleccionado] = React.useState(null);

  const handleUnidadChange = (selectedUnidad) => {
    setUnidadSeleccionada(selectedUnidad);
  };

  const handleTipoActivoChange = (selectedTipoActivo) => {
    setTipoActivoSeleccionado(selectedTipoActivo);
  };

  const handleActivoChange = (selectedActivo) => {
    setActivoSeleccionado(selectedActivo);
  };

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Typography variant="h5" fontWeight="600" sx={{ color: '#001F3F', mb: 3 }}>
        Listado de Activos por Unidad y Tipo
      </Typography>

      <Grid container spacing={3}>
        {/* Panel de Filtros */}
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 3, border: '1px solid #e0e0e0', height: 'fit-content' }}>
            <Typography variant="h6" sx={{ color: '#001F3F', mb: 2, fontWeight: 600 }}>
              Filtros
            </Typography>
            <Divider sx={{ mb: 3 }} />
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <ComboBoxWithSearch
                label="Organización (Unidad)"
                onChange={handleUnidadChange}
              />
              <ComboBoxTipoActivo
                label="Tipo de Activo"
                onChange={handleTipoActivoChange}
              />
              <ComboBoxActivo 
                label="Activo" 
                onChange={handleActivoChange} 
              />
            </Box>
          </Paper>
        </Grid>

        {/* Tabla de Resultados */}
        <Grid item xs={12} md={8}>
          <Tabla tableTitle="Vulnerabilidades por Activo" />
        </Grid>
      </Grid>
    </Container>
  );
};

export const ValDeImpac = () => {
  const [unidadSeleccionada, setUnidadSeleccionada] = React.useState(null);
  const [tipoActivoSeleccionado, setTipoActivoSeleccionado] =
    React.useState(null);
  const [activoSeleccionado, setActivoSeleccionado] = React.useState(null);

  const handleUnidadChange = (selectedUnidad) => {
    setUnidadSeleccionada(selectedUnidad);
  };

  const handleTipoActivoChange = (selectedTipoActivo) => {
    setTipoActivoSeleccionado(selectedTipoActivo);
  };

  const handleActivoChange = (selectedActivo) => {
    setActivoSeleccionado(selectedActivo);
  };

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Typography variant="h5" fontWeight="600" sx={{ color: '#001F3F', mb: 3 }}>
        Activos: Valor de Impacto
      </Typography>

      <Grid container spacing={3}>
        {/* Panel de Filtros */}
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 3, border: '1px solid #e0e0e0', height: 'fit-content' }}>
            <Typography variant="h6" sx={{ color: '#001F3F', mb: 2, fontWeight: 600 }}>
              Filtros
            </Typography>
            <Divider sx={{ mb: 3 }} />
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <ComboBoxWithSearch
                label="Organización (Unidad)"
                onChange={handleUnidadChange}
              />
              <ComboBoxTipoActivo
                label="Tipo de Activo"
                onChange={handleTipoActivoChange}
              />
              <ComboBoxActivo 
                label="Activo" 
                onChange={handleActivoChange} 
              />
            </Box>
          </Paper>
        </Grid>

        {/* Tabla de Resultados */}
        <Grid item xs={12} md={8}>
          <Tabla1
            tableTitle="Vulnerabilidades para el Activo:"
            unidadSeleccionada={unidadSeleccionada}
            tipoActivoSeleccionado={tipoActivoSeleccionado}
            activoSeleccionado={activoSeleccionado}
          />
        </Grid>
      </Grid>
    </Container>
  );
};
